exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nIROcUfy7P_wuqffT-c7N{position:fixed;pointer-events:\"none\";z-index:1000;font-size:12px;font-weight:400}html[dir] ._1nIROcUfy7P_wuqffT-c7N{border:1px solid transparent;border-radius:2px;padding:2px 5px;background-color:\"[theme:themeLighter, default:#DEECF9]\";-webkit-box-shadow:0 0 6px 0 \"[theme:blackTranslucent40, default:rgba(0, 0, 0, .4)]\";box-shadow:0 0 6px 0 \"[theme:blackTranslucent40, default:rgba(0, 0, 0, .4)]\"}", ""]);
// Exports
exports.locals = {
	"dragTip": "_1nIROcUfy7P_wuqffT-c7N"
};